import { memo, useState } from 'react';
import PropTypes from "prop-types";
import styles from './VASMessage.module.scss';
import { createMarkup } from "../../../utils/helperServices";
import * as Analytics from "../../../services/analyticsUtag";

const VASMessage = ({ messageTitle, messageDescription }) => {
    const [isOpen, setIsOpen] = useState(false);
    
    if (isOpen) {
        const pageName = Analytics.getUtagData(["page_name"]).page_name;

        Analytics.link({
            link_type : "o",
            page_tool_event: "use",
            page_tool_name: `${pageName}: why get contract cover`,
        });
    }

    return (
        <div className={styles["message-container"]}>
            <div className={`${styles["message-title"]} ${isOpen ? styles["open"] : ""}`} 
                 onClick={() => setIsOpen(!isOpen)}>{messageTitle}</div>

            <div className={`${styles["message-item"]} ${!isOpen ? styles["collapsed"] : ""}`}>
                <div className={styles["message-description"]} 
                     dangerouslySetInnerHTML={createMarkup(messageDescription)}>
                </div>
            </div>
        </div>
    )
}

VASMessage.propTypes = {
    messageTitle: PropTypes.string,
    messageDescription: PropTypes.string
};

export default memo(VASMessage);
